import { useEffect } from 'react';

/**
 * SchemaComponent - Injects JSON-LD schema markup into the document head
 * Handles both single schema and array of schemas
 *
 * @param {Object|Array} schema - Schema.org structured data
 * @param {string} id - Unique identifier for the script tag
 */
const SchemaComponent = ({ schema, id = 'schema-markup' }) => {
  useEffect(() => {
    if (!schema) return;

    // Remove existing script if present (for updates)
    const existing = document.getElementById(id);
    if (existing) {
      existing.remove();
    }

    // Create and inject schema script
    const script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    // Cleanup on unmount
    return () => {
      const element = document.getElementById(id);
      if (element) {
        element.remove();
      }
    };
  }, [schema, id]);

  return null; // This component doesn't render anything visible
};

export default SchemaComponent;
